import { useAuth } from 'contexts';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const Landing = () => {
  const navigate = useNavigate();
  const searchParams = useSearchParams()[0];

  const { login } = useAuth();

  useEffect(() => {
    login(searchParams.get('code')).then(() => navigate('/redirect'));
  }, [login, navigate, searchParams]);

  return <div>Authorizing...</div>;
};

export default Landing;
